import { render, staticRenderFns } from "./HistoryOperations.vue?vue&type=template&id=6d65b4b0"
import script from "./HistoryOperations.vue?vue&type=script&lang=js"
export * from "./HistoryOperations.vue?vue&type=script&lang=js"
import style0 from "./HistoryOperations.vue?vue&type=style&index=0&id=6d65b4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports